import { useState } from "react";
import Swal from "sweetalert2";
import { firestore } from "../../firebase/firebase";
import "./forms.css";
import firebase from "firebase/compat/app";
import { CheckInput, RadioInput } from "./input";
const timestamp = firebase.firestore.FieldValue.serverTimestamp();
const type = "marketingform";

export default function MarketingForm() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [whereFindCheck, setwhereFindCheck] = useState([
    {
      name: "LinkedIn",
      value: "",
    },
    {
      name: "Instagram",
      value: "",
    },
    {
      name: "Google Search",
      value: "",
    },
    {
      name: "Clubhouse",
      value: "",
    },
    {
      name: "Other",
      value: "",
    },
  ]);
  const [needHelpWith, setNeedHelpWith] = useState([
    {
      name: "Social Media marketing Strategy",
      value: "",
    },
    {
      name: "Conent Marketing or Copywriting",
      value: "",
    },
    {
      name: "Content Strategy",
      value: "",
    },
    {
      name: "Consulting",
      value: "",
    },
    {
      name: "1:1 Coaching",
      value: "",
    },
  ]);
  const [link, setLink] = useState("");
  const [typesOfProject, setTypesOfProject] = useState("");
  const [terms, setTerms] = useState("");
  const [budget, setBudget] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      firstName,
      lastName,
      email,
      "Where did you find me?": whereFindCheck
        .filter((option) => option.value != "")
        .map((option) => option.value),
      "What do you need my help with?": needHelpWith
        .filter((option) => option.value != "")
        .map((option) => option.value),
      "Do you have your company website and/or Social Media Pages? If yes, please provide your company website and/or social media pages.": link,
      "Type of Project": typesOfProject,
      "What's your monthly budget for an ongoing project or total budget for a one time project?": budget,
      "Do you accept our terms & conditions?": terms,
      type,
      timestamp,
    };
    firestore
      .collection("EmailQueries")
      .add(data)
      .then((docRef) => {
        Swal.fire({
          position: "top",
          icon: "success",
          title: "We will get back to you in 24hrs",
          showConfirmButton: false,
          timer: 1500,
        });
        document.getElementById("resetBtn").click();
        // console.log("doc", docRef);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <form className={"scrobitsQuoteForm"} onSubmit={handleSubmit}>
      <div className={"formGroup"}>
        <label htmlFor="fName" className={"formLabel"}>
          First Name <span className={"red"}>*</span>
        </label>
        <input
          type="text"
          id="fName"
          className={"formInput"}
          placeholder="Your Answer"
          value={firstName}
          onChange={(e) => {
            setFirstName(e.currentTarget.value);
          }}
          required
        />
      </div>
      <div className={"formGroup"}>
        <label htmlFor="lName" className={"formLabel"}>
          Last Name <span className={"red"}>*</span>
        </label>
        <input
          type="text"
          id="lName"
          className={"formInput"}
          placeholder="Your Answer"
          value={lastName}
          onChange={(e) => {
            setLastName(e.currentTarget.value);
          }}
          required
        />
      </div>
      <div className={"formGroup"}>
        <label htmlFor="email" className={"formLabel"}>
          Email <span className={"red"}>*</span>
        </label>
        <input
          type="email"
          id="email"
          className={"formInput"}
          placeholder="Your Answer"
          value={email}
          onChange={(e) => {
            setEmail(e.currentTarget.value);
          }}
          required
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          Where did you find me? <span className={"red"}>*</span>
        </label>
        {whereFindCheck.map((check, idx) => (
          <CheckInput
            key={idx}
            name={check.name}
            value={check.value}
            setValue={(e) => {
              setwhereFindCheck(
                whereFindCheck.map((option) => {
                  return option.name === check.name
                    ? option.value === ""
                      ? { ...option, value: option.name }
                      : { ...option, value: "" }
                    : { ...option };
                })
              );
            }}
          />
        ))}
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          What do you need my help with? <span className={"red"}>*</span>
        </label>
        {needHelpWith.map((check, idx) => (
          <CheckInput
            key={idx}
            name={check.name}
            value={check.value}
            setValue={(e) => {
              setNeedHelpWith(
                needHelpWith.map((option) => {
                  return option.name === check.name
                    ? option.value === ""
                      ? { ...option, value: option.name }
                      : { ...option, value: "" }
                    : { ...option };
                })
              );
            }}
          />
        ))}
      </div>
      <div className={"formGroup"}>
        <label htmlFor="fame" className={"formLabel"}>
          Do you have your company website and/or Social Media Pages? If yes,
          please provide your company website and/or social media pages.
          <span className={"red"}>*</span>
        </label>
        <textarea
          name="link"
          id="link"
          className={"formInput"}
          onChange={(e) => {
            setLink(e.currentTarget.value);
            var textarea = e.currentTarget;
            textarea.style.height = textarea.scrollHeight + "px";
          }}
          value={link}
          required
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          Type of Project <span className={"red"}>*</span>
        </label>
        <RadioInput
          options={["Ongoing", "One-time"]}
          id="typeOfProject"
          value={typesOfProject}
          setValue={setTypesOfProject}
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          What&#39;s your monthly budget for an ongoing project or total budget
          for a one time project? <span className={"red"}>*</span>
        </label>
        <RadioInput
          options={[
            "$500 - $1,000",
            "$1,000 - $3,000",
            "$3,000 - $5,000",
            "$5,000 - $8,000",
            "Above $8,000",
          ]}
          id="budget"
          value={budget}
          setValue={setBudget}
        />
      </div>
      <div className={"formGroup"}>
        <label className={"formLabel"}>
          Do you accept our terms &amp; conditions?{" "}
          <span className={"red"}>*</span>
        </label>
        <RadioInput
          options={["yes", "no"]}
          id="termsAndCondition"
          value={terms}
          setValue={setTerms}
        />
      </div>
      <div className={"formGroupBtn"}>
        <input type="submit" className={"formInput"} value="Submit" />
        <input
          type="reset"
          className={"formInput"}
          value="reset"
          onClick={() => {
            setFirstName("");
            setLastName("");
            setEmail("");
            setwhereFindCheck([
              {
                name: "LinkedIn",
                value: "",
              },
              {
                name: "Instagram",
                value: "",
              },
              {
                name: "Google Search",
                value: "",
              },
              {
                name: "Clubhouse",
                value: "",
              },
              {
                name: "Other",
                value: "",
              },
            ]);
            setNeedHelpWith([
              {
                name: "Social Media marketing Strategy",
                value: "",
              },
              {
                name: "Conent Marketing or Copywriting",
                value: "",
              },
              {
                name: "Content Strategy",
                value: "",
              },
              {
                name: "Consulting",
                value: "",
              },
              {
                name: "1:1 Coaching",
                value: "",
              },
            ]);
            setLink("");
            setTypesOfProject("");
            setTerms("");
            setBudget("");
          }}
          id="resetBtn"
        />
      </div>
    </form>
  );
}
